import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=2e45d535&scoped=true&lang=stylus"
script.__scopeId = "data-v-2e45d535"

export default script